
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funeral-recommend/[parlor]/[crema]/[facility]",
      function () {
        return require("private-next-pages/funeral-recommend/[parlor]/[crema]/[facility].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funeral-recommend/[parlor]/[crema]/[facility]"])
      });
    }
  